import { toastr } from "react-redux-toastr";
import Api from "../../utils/config/api";
import {
  SEED_FEEDBACK,
  RESET_FB_STATE,
  SET_FB_RES_DATA,
  SET_FB_EDIT_SEEN,
  FEEDBACK_OVERVIEW,
  FEEDBACK_DAILY_RESPONSES,
  FEEDBACK_RATINGS_OVERTIME,
  SET_NEG_FB_BETA_USERS,
} from "../types";

export const setFeedbackSeen = () => (dispatch) => {
  dispatch({
    payload: true,
    type: SET_FB_EDIT_SEEN,
  });
};

export const setNegFbBetaUserStatus = (status) => (dispatch) => {
  dispatch({
    payload: status,
    type: SET_NEG_FB_BETA_USERS,
  });
};

export const seedFeedback = (storeId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/feedback/${storeId}/seed`)
      .then((res) => {
        dispatch({
          type: SEED_FEEDBACK,
          payload: res.data.payload?.[0]?.feedback?.[0],
        });

        return resolve(res.data.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const getDraftFeedbackStatus = (storeId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/feedback/draft/${storeId}`)
      .then((res) => {
        return resolve(res.data.payload?.is_draft);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const getExistingFeedback = (storeId, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/feedback/${storeId}${isCache ? "?cache=true" : ""}`)
      .then((res) => {
        dispatch({
          type: SET_FB_RES_DATA,
          payload: res.data.payload,
        });

        return resolve(res.data.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const getFbNegAlertForGrp = (storeId) => {
  return new Promise((resolve, reject) => {
    const url = `/v1/feedback/negative-feedback-alerts/store-wise-settings/${storeId}`;

    Api.get(url)
      .then((res) => resolve(res.data.payload))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const updateFeedback = (storeId, data, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/feedback/${storeId}${isCache ? "?cache=true" : ""}`, data)
      .then((res) => {
        dispatch({
          type: SET_FB_RES_DATA,
          payload: res.data.payload,
        });

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            `Validation ${
              err?.response?.data?.errors?.length > 1 ? "errors" : "error"
            }`,
            err?.response?.data?.errors?.reduce(
              (prev, currErr) => `${currErr?.msg}, ${prev}`,
              ""
            )
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const updateFbChannel = (storeId, data, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.patch(
      `/v1/feedback/${storeId}/channels${isCache ? "?cache=true" : ""}`,
      data
    )
      .then((res) => {
        dispatch({
          type: SET_FB_RES_DATA,
          payload: res.data.payload,
        });

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error("Validation Error", errObj?.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const updateFbNegAlertForGrp = (entityId, data, isCache) => {
  return new Promise((resolve, reject) => {
    const url = `/v1/feedback/negative-feedback-alerts/store-wise-settings/${entityId}${
      isCache ? "?cache=true" : ""
    }`;

    Api.put(url, data)
      .then((res) => resolve(res.data.payload))
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation Error",
            err?.response?.data?.errors
              ?.map((errObj) => errObj?.msg)
              ?.join(", ")
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              "Failed to update negative feedback alert settings for other stores!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const toggleFeedbackActiveStatus = (storeId, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/feedback/${storeId}/activate`, data)
      .then((res) => {
        dispatch({
          type: SET_FB_RES_DATA,
          payload: res.data.payload,
        });

        return resolve(res.data.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const sendTestFeed = (data, storeId) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`v1/feedback/${storeId}/test?cache=true`, data)
      .then((res) => {
        toastr.success("Success", "Successfully sent test message");
        return resolve(res.data.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const clearCachedFeedbackData = (storeId) => {
  return new Promise((resolve, reject) => {
    Api.delete(`/v1/feedback/${storeId}`)
      .then((res) => resolve(res.data.payload))
      .catch((err) => reject(err?.response?.data?.message));
  });
};

export const getRecentFeedbacks =
  (storeId, params, isAllStoresSelected, groupId) => () => {
    const { filter, rating, customer_id, period, start, end, page } = params;

    const url = isAllStoresSelected
      ? `v1/groups/${groupId}/recent-feedbacks?page=${page || 1}&filter=${
          filter || "all"
        }${rating ? `&rating=${rating}` : ""}&period=${period || "7"}${
          customer_id ? `&customer_id=${customer_id}` : ""
        }${(start && `&start=${start}`) || ""}${(end && `&end=${end}`) || ""}`
      : `v1/insights/${storeId}/recent-feedbacks?page=${page || 1}&filter=${
          filter || "all"
        }${rating ? `&rating=${rating}` : ""}&period=${period || "7"}${
          customer_id ? `&customer_id=${customer_id}` : ""
        }${(start && `&start=${start}`) || ""}${(end && `&end=${end}`) || ""}`;

    return new Promise((resolve, reject) => {
      Api.get(url)
        .then((res) => resolve(res.data.payload))
        .catch((err) => {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        });
    });
  };

export const exportRecentFeedbackCall = (
  storeId,
  params,
  isAllStoresSelected,
  groupId
) => {
  const { filter, rating, customer_id, period, start, end, page } = params;

  const url = isAllStoresSelected
    ? `v1/groups/${groupId}/recent-feedbacks?page=${page || 1}&filter=${
        filter || "all"
      }${rating ? `&rating=${rating}` : ""}&period=${period || "7"}${
        customer_id ? `&customer_id=${customer_id}` : ""
      }${(start && `&start=${start}`) || ""}${(end && `&end=${end}`) || ""}`
    : `v1/insights/${storeId}/recent-feedbacks?page=${page || 1}&filter=${
        filter || "all"
      }${rating ? `&rating=${rating}` : ""}&period=${period || "7"}${
        customer_id ? `&customer_id=${customer_id}` : ""
      }${(start && `&start=${start}`) || ""}${(end && `&end=${end}`) || ""}`;

  return new Promise((resolve, reject) => {
    Api.get(`${url}&attachment=true`)
      .then((res) => resolve(res))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};
export const getFbQuickGlance = (entityId, params) => () => {
  const { period, start, end } = params;

  const url = `/v1/insights/feedback-quick-glance/${entityId}?period=${
    period || "7"
  }${(start && `&start=${start}`) || ""}${(end && `&end=${end}`) || ""}`;

  return new Promise((resolve, reject) => {
    Api.get(url)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

// Feedback Analytics Actions

export const getFeedbackOverview =
  (storeId, period, start, end, isAllStoresSelected, groupId) => (dispatch) => {
    const url = isAllStoresSelected
      ? `/v1/groups/${groupId}/feedback-overview?period=${period}${
          (start && `&start=${start}`) || ""
        }${(end && `&end=${end}`) || ""}`
      : `/v1/insights/${storeId}/feedback-overview?period=${period}${
          (start && `&start=${start}`) || ""
        }${(end && `&end=${end}`) || ""}`;
    return new Promise((resolve, reject) => {
      Api.get(url)
        .then((res) => {
          dispatch({
            type: FEEDBACK_OVERVIEW,
            payload: res.data.payload?.[0] || {},
          });

          return resolve(res.data.payload?.[0] || {});
        })
        .catch((err) => {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        });
    });
  };
export const getFbRatingsOvertime =
  (storeId, period, start, end, isAllStoresSelected, groupId) => (dispatch) => {
    const url = isAllStoresSelected
      ? `/v1/groups/${groupId}/ratings-overtime?period=${period}${
          (start && `&start=${start}`) || ""
        }${(end && `&end=${end}`) || ""}`
      : `/v1/insights/${storeId}/ratings-overtime?period=${period}${
          (start && `&start=${start}`) || ""
        }${(end && `&end=${end}`) || ""}`;
    return new Promise((resolve, reject) => {
      Api.get(url)
        .then((res) => {
          dispatch({
            type: FEEDBACK_RATINGS_OVERTIME,
            payload: res.data.payload,
          });

          return resolve(res.data.payload);
        })
        .catch((err) => {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        });
    });
  };
export const getFbDailyResponses =
  (storeId, period, start, end, isAllStoresSelected, groupId) => (dispatch) => {
    const url = isAllStoresSelected
      ? `/v1/groups/${groupId}/feedback-daily-responses?period=${period}${
          (start && `&start=${start}`) || ""
        }${(end && `&end=${end}`) || ""}`
      : `/v1/insights/${storeId}/feedback-daily-responses?period=${period}${
          (start && `&start=${start}`) || ""
        }${(end && `&end=${end}`) || ""}`;
    return new Promise((resolve, reject) => {
      Api.get(url)
        .then((res) => {
          dispatch({
            type: FEEDBACK_DAILY_RESPONSES,
            payload: res.data.payload,
          });

          return resolve(res.data.payload);
        })
        .catch((err) => {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        });
    });
  };

export const getNoOfActiveFeedbacks = (groupId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/groups/${groupId}/active-feedbacks-count`)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );
        return reject(err?.response?.data?.message);
      });
  });
};

export const resetFbState = () => (dispatch) => {
  dispatch({
    type: RESET_FB_STATE,
  });
};

// Negative Feedback Actions

export const setNegativeFbActionReward = (data, storeId) => () => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/feedback/${storeId}/negative-feedback-actions/reward`, data)
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            `Validation ${
              err?.response?.data?.errors?.length > 1 ? "errors" : "error"
            }`,
            err?.response?.data?.errors?.reduce(
              (prev, currErr) => `${currErr?.msg}, ${prev}`,
              ""
            )
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const getNegativeFbActionTemplates = (rewardType, channel) => () => {
  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/feedback/negative-feedback-actions/${rewardType}/${channel}/seed`
    )
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const setNegativeFbActionChannel = (data, storeId, feedbackId) => () => {
  return new Promise((resolve, reject) => {
    Api.put(
      `/v1/feedback/${storeId}/negative-feedback-actions/${feedbackId}/channel`,
      data
    )
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const setNegativeFbActionMessage = (data, storeId, feedbackId) => () => {
  return new Promise((resolve, reject) => {
    Api.post(
      `/v1/feedback/${storeId}/negative-feedback-actions/${feedbackId}/send`,
      data
    )
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const getNegFbApologyCount = (entityId, customerId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/insights/apology-count/${entityId}/${customerId}`)
      .then((res) => resolve(res.data.payload))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const getNegFbActionMsgDlvryStatus = (feedbackId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/feedback/negative-feedback-actions/apology-message/${feedbackId}`
    )
      .then((res) => resolve(res.data.payload))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const getNegFbRewardsList = (storeId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/feedback/${storeId}/negative-feedback-actions/rewards-list`)
      .then((res) => resolve(res.data.payload))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const getCompareStoreForFb = (query) => {
  const end = query?.end || "";
  const start = query?.start || "";
  const period = query?.period || "";
  const groupId = query?.groupId || "";

  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/groups/${groupId}/feedback-insights?period=${period}&start=${start}&end=${end}`
    )
      .then((res) => resolve(res.data.payload))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const exportCompareStoreForFb = (query) => {
  const end = query?.end || "";
  const start = query?.start || "";
  const period = query?.period || "";
  const groupId = query?.groupId || "";

  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/groups/${groupId}/feedback-insights?period=${period}&start=${start}&end=${end}&attachment=true`
    )
      .then((res) => resolve(res.data))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};
